import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import AppLayout from "../layouts/AppLayout.vue";
import Login from "../pages/auth/Login.vue";
import Register from "@/pages/auth/Register.vue";
import RecoverPassword from "@/pages/auth/RecoverPassword.vue";
import VerifyCode from "@/pages/auth/VerifyCode.vue";
import ResetPassword from "@/pages/auth/ResetPassword.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "dashboard" },
  },
  {
    name: "admin",
    path: "/",
    component: AppLayout,
    redirect: { name: "dashboard" },
    children: [
      {
        name: "dashboard",
        path: "dashboard",
        component: () => import("../pages/admin/dashboard/Dashboard.vue"),
        meta: { loginRequired: true },
      },
      {
        name: "stake",
        path: "stake",
        component: () => import("../pages/stakes/StakeView.vue"),
        meta: { loginRequired: true },
      },
      {
        name: "history",
        path: "history",
        component: () => import("../pages/history/HistoryView.vue"),
        meta: { loginRequired: true },
      },
      {
        name: "network",
        path: "network",
        component: () => import("../pages/network/NetworkView.vue"),
        meta: { loginRequired: true },
      },
      {
        name: "operations",
        path: "operations",
        component: () => import("../pages/operations/OperationsView.vue"),
        meta: { loginRequired: true },
      },
      {
        name: "copytrade",
        path: "copytrade",
        component: () => import("../pages/copytrade/CopytradeView.vue"),
        meta: { loginRequired: true },
      },
      {
        name: "primezord",
        path: "primezord",
        component: () => import("../pages/primezord/PrimezordView.vue"),
        meta: { loginRequired: true },
      },
      {
        name: "profile",
        path: "profile",
        component: () => import("../pages/profile/ProfileView.vue"),
        meta: { loginRequired: true },
      },
      {
        name: "support",
        path: "support",
        component: () => import("../pages/support/SupportView.vue"),
        meta: { loginRequired: true },
      },
      {
        name: "tutoriais",
        path: "tutoriais",
        component: () => import("../pages/tutoriais/TutoriaisView.vue"),
        meta: { loginRequired: true },
      },
    ],
  },
  {
    path: "/auth/login",
    component: Login,
    meta: { loginRequired: false },
  },
  {
    path: "/auth/register",
    component: Register,
    meta: { loginRequired: false },
  },
  {
    path: "/auth/recover-password",
    component: RecoverPassword,
    meta: { loginRequired: false },
  },
  {
    path: "/auth/verify-code",
    component: VerifyCode,
    meta: { loginRequired: false },
  },
  {
    path: "/auth/reset-password",
    component: ResetPassword,
    meta: { loginRequired: false },
  },
  {
    name: "404",
    path: "/404",
    component: () => import("../pages/404.vue"),
  },
  {
    name: "accept-terms",
    path: "/accept-terms",
    component: () => import("../pages/AcceptTerms.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    } else {
      window.scrollTo(0, 0);
    }
  },
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem("accessToken");
  const isLoginRoute = to.path.startsWith("/auth");
  if (!to.meta.loginRequired) {
    return next();
  }

  if (!isLoggedIn && !isLoginRoute) {
    return next("/auth/login");
  }

  if (isLoggedIn && isLoginRoute) {
    return next({ name: "dashboard" });
  }

  return next();
});

export default router;
